import type { ReactNode } from "react";
import { Level, type Size } from "@/shared/components/generic/UiEnums.ts";
import IconButton from "@/shared/components/generic/button/IconButton.tsx";
import IconCalendarIncomingArrow from "@/shared/components/generic/icons/IconCalendarIncomingArrow.tsx";
import BasicTooltipWithOffset from "@/pages/human-resources/time-management/components/BasicTooltipWithOffset.tsx";

interface Properties {
  tooltipLabel: string;
  disabled: boolean;
  buttonSize: Size;
  onClick: () => void;
}

export default function ScheduleImportDialogOpener(
  props: Properties,
): ReactNode {
  return (
    <>
      <BasicTooltipWithOffset title={props.tooltipLabel}>
        <IconButton
          icon={IconCalendarIncomingArrow}
          level={Level.TERTIARY}
          size={props.buttonSize}
          onClick={props.onClick}
          disabled={props.disabled}
        />
      </BasicTooltipWithOffset>
    </>
  );
}
